import { ThumbDownOutlineIcon } from './ThumbDownOutlineIcon';

/**
 * author: Google
 * id 00EE8027-00FE-43B8-ACEC-7779E39D6E29
 * name thumb-down-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thumb-down-outline.svg
 * tags
 */
export const DislikeOutlineIcon = ThumbDownOutlineIcon;
export default DislikeOutlineIcon